"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExecutives = exports.defaultPropertyAgents = void 0;
exports.defaultPropertyAgents = {
    translate: {
        ourPropertyAgents: 'Our Property Agents',
        joinOurTeam: 'Join Our Team',
    },
    items: [
        {
            agentId: 536,
            agentUrl: 'https://google.com/',
            fullName: 'Alan McKenzie',
            profileImageUrl: 'https://images.okay.com/Agent/Original/536_636452416314215537.jpg',
            spokenLanguagesIds: [6],
        },
        {
            agentId: 564,
            agentUrl: 'https://google.com/',
            fullName: 'Alexandra Collado',
            profileImageUrl: 'https://images.okay.com/Agent/Original/564_636536238490448889.jpg',
            spokenLanguagesIds: [6, 7, 18, 23],
        },
        {
            agentId: 440,
            agentUrl: 'https://google.com/',
            fullName: 'Alexandra Tulleners',
            profileImageUrl: 'https://images.okay.com/Agent/Original/440_635821563344506925.jpg',
            spokenLanguagesIds: [6, 8],
        },
        {
            agentId: 325,
            agentUrl: 'https://google.com/',
            fullName: 'Alexis S Davies',
            profileImageUrl: 'https://images.okay.com/Agent/Original/325_635439708988502494.jpg',
            spokenLanguagesIds: [6],
        },
        {
            agentId: 596,
            agentUrl: 'https://google.com/',
            fullName: 'Amelia Ng',
            profileImageUrl: 'https://images.okay.com/Agent/Original/596_636679638335227282.jpg',
            spokenLanguagesIds: [2, 6, 3],
        },
        {
            agentId: 321,
            agentUrl: 'https://google.com/',
            fullName: 'Andrea Adams Ott',
            profileImageUrl: 'https://images.okay.com/Agent/Original/321_635439709672251695.jpg',
            spokenLanguagesIds: [6],
        },
        {
            agentId: 505,
            agentUrl: 'https://google.com/',
            fullName: 'Anne Jones',
            profileImageUrl: 'https://images.okay.com/Agent/Original/505_636166456718398066.jpg',
            spokenLanguagesIds: [6, 7],
        },
        {
            agentId: 457,
            agentUrl: 'https://google.com/',
            fullName: 'Antoine Devolz',
            profileImageUrl: 'https://images.okay.com/Agent/Original/457_635969208046096764.jpg',
            spokenLanguagesIds: [6, 7],
        },
        {
            agentId: 534,
            agentUrl: 'https://google.com/',
            fullName: 'Barry Tse',
            profileImageUrl: 'https://images.okay.com/Agent/Original/534_636452411504259089.jpg',
            spokenLanguagesIds: [2, 6, 3],
        },
        {
            agentId: 244,
            agentUrl: 'https://google.com/',
            fullName: 'Belinda M L Woo',
            profileImageUrl: 'https://images.okay.com/Agent/Original/244_636245719616486377.jpg',
            spokenLanguagesIds: [2, 6],
        },
        {
            agentId: 563,
            agentUrl: 'https://google.com/',
            fullName: 'Betty Pang',
            profileImageUrl: 'https://images.okay.com/Agent/Original/563_636663038067082822.jpg',
            spokenLanguagesIds: [2, 6],
        },
        {
            agentId: 554,
            agentUrl: 'https://google.com/',
            fullName: 'Brenda Chu',
            profileImageUrl: 'https://images.okay.com/Agent/Original/554_636560184130362167.jpg',
            spokenLanguagesIds: [2, 6, 3],
        },
    ],
};
exports.defaultExecutives = {
    translate: {
        ourPropertyAgents: 'Leadership team',
        joinOurTeam: 'Join Our Team',
    },
    items: [
        {
            agentId: 312,
            agentUrl: 'https://google.com/',
            fullName: 'Andrea Adams Ott',
            title: 'Director - Residential Division',
            profileImageUrl: 'https://images.okay.com/Agent/Original/321_635439709672251695.jpg',
            spokenLanguagesIds: [],
        },
    ],
};
